var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.333,
    height: 78.349
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bell_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h57.5v57.5H0z",
    "data-name": "Rectangle 184"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bell_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h30.818v30.818H0z",
    "data-name": "Rectangle 185"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 446"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 421"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bell_svg__a)",
    "data-name": "Group 420",
    transform: "translate(0 20.849)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed6e45",
    d: "M52.261 28.75a23.51 23.51 0 1 1-23.51-23.51 23.51 23.51 0 0 1 23.51 23.51",
    "data-name": "Path 482"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.793 31.775v-5.313a9.043 9.043 0 0 0-9.043-9.043 9.043 9.043 0 0 0-9.043 9.043v5.313c0 2.889-.792 3.993-2.289 6.464h22.665c-1.5-2.471-2.289-3.575-2.289-6.464",
    "data-name": "Path 483"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.75 42.85a3.413 3.413 0 0 1-3.413-3.413h6.824a3.413 3.413 0 0 1-3.413 3.413",
    "data-name": "Path 484"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.75 14.65a2.77 2.77 0 1 0 2.77 2.77 2.77 2.77 0 0 0-2.77-2.77m0 4.434a1.664 1.664 0 1 1 1.664-1.664 1.664 1.664 0 0 1-1.664 1.664",
    "data-name": "Path 485"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed6e45",
    d: "M28.75 57.5A28.75 28.75 0 0 1 8.421 8.421a28.75 28.75 0 1 1 40.658 40.658A28.56 28.56 0 0 1 28.75 57.5m0-55.257a26.507 26.507 0 0 0-18.743 45.25 26.507 26.507 0 1 0 37.486-37.486A26.33 26.33 0 0 0 28.75 2.243",
    "data-name": "Path 486"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#ed6e45",
    clipPath: "url(#bell_svg__b)",
    "data-name": "Group 423",
    transform: "translate(38.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.651 19.358a1.19 1.19 0 0 1-.842-2.032l7.8-7.8a1.19 1.19 0 0 1 1.683 1.684l-7.8 7.8a1.19 1.19 0 0 1-.842.349",
    "data-name": "Path 487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.651 19.655a1.488 1.488 0 0 1-1.052-2.54l7.8-7.8a1.488 1.488 0 0 1 2.1 2.1l-7.8 7.8a1.48 1.48 0 0 1-1.052.436m7.8-10.181a.9.9 0 0 0-.632.261l-7.8 7.8a.897.897 0 0 0 1.268 1.268l7.8-7.8a.892.892 0 0 0-.631-1.524",
    "data-name": "Path 488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.332 30.521a1 1 0 0 1-.178-.013l-12.982-1.95a1.19 1.19 0 0 1 .354-2.354l12.982 1.95a1.191 1.191 0 0 1-.175 2.368",
    "data-name": "Path 489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.332 30.819a1.5 1.5 0 0 1-.222-.017l-12.982-1.95a1.488 1.488 0 0 1 .442-2.943l12.982 1.95a1.488 1.488 0 0 1-.22 2.96m-12.984-4.335a.893.893 0 0 0-.132 1.776l12.982 1.95a1 1 0 0 0 .134.01.893.893 0 0 0 .131-1.776l-12.982-1.95a1 1 0 0 0-.133-.01",
    "data-name": "Path 490"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.437 15.661a1.19 1.19 0 0 1-1.176-1.014L.311 1.665a1.19 1.19 0 1 1 2.354-.354l1.95 12.986a1.19 1.19 0 0 1-1 1.354 1 1 0 0 1-.178.013",
    "data-name": "Path 491"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.437 15.958a1.5 1.5 0 0 1-1.47-1.267L.016 1.709A1.488 1.488 0 0 1 2.372.291a1.48 1.48 0 0 1 .588.976l1.95 12.982a1.49 1.49 0 0 1-1.25 1.692 1.5 1.5 0 0 1-.223.017M1.49.6a.893.893 0 0 0-.885 1.021L2.555 14.6a.89.89 0 0 0 1.015.75.893.893 0 0 0 .75-1.016L2.371 1.356A.894.894 0 0 0 1.49.6",
    "data-name": "Path 492"
  })))));
};
export default SvgBell;